import { Pipe, PipeTransform } from '@angular/core';
import { Jurisdictions } from '../constants';

@Pipe({
  name: 'jurisdiction'
})
export class JurisdictionPipe implements PipeTransform {
  transform(value: string, twoDigitCode?: any): any {
    if (twoDigitCode) {
      // Return two digit code of jurisdiction from value i.e 'US-TX' or 'US_TX'
      return value.split(new RegExp(['-', '_'].join('|'), 'g'))[1];
    }
    return Jurisdictions[value] ? Jurisdictions[value] : value;
  }
}
